<template src="./index.html" />
<script>
/* eslint-disable vue/require-prop-types */
import { validationMixin } from 'vuelidate';
import {
  required,
  sameAs,
  minLength,
} from 'vuelidate/lib/validators';
import AWS from '@/services/AwsSdk';
export default {
  name: 'ConfirmResetPassword',
  mixins: [validationMixin],
  props: ['email'],
  data: () => ({
    errorWithCode: null,
    showNewPassword: false,
    showConfirmPassword: false,
    password: {
      code: null,
      newPassword: null,
      repeatPassword: null,
    },
  }),
  validations: {
    password: {
      newPassword: {
        required, minLength: minLength(8),
      },
      repeatPassword: {
        required, sameAs: sameAs('newPassword'),
      },
      code: {
        required, minLength: minLength(6),
      },
    },
  },
  computed: {
    verificationCodeErrors() {
      const errors = [];
      if (!this.$v.password.code.$dirty) return errors;
      if (!this.$v.password.code.minLength) {
        errors.push('Verification code must be at 6 characters long');
      }
      if (!this.$v.password.code.required) {
        errors.push('Please enter required value');
      }
      if (this.errorWithCode) {
        errors.push(this.errorWithCode);
      }
      return errors;
    },
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.password.newPassword.$dirty) return errors;
      if (!this.$v.password.newPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.newPassword.minLength) {
        errors.push('Password must be with 8 characters long');
      }
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.password.repeatPassword.$dirty) return errors;
      if (!this.$v.password.repeatPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.repeatPassword.sameAs) {
        errors.push('Confirm Password must be the same');
      }
      return errors;
    },
  },
  created() {
    if (!this.email) {
      this.$router.push('reset-password');
    }
  },
  methods: {
    confirmResetPassword() {
      this.$v.password.$touch();
      if (!this.$v.password.$invalid) {
        const dataToSend = {
          email: this.email,
          code: this.password.code,
          password: this.password.newPassword,
        };
        this.$store.commit('spinner', true);
        AWS.confirmResetPassword(dataToSend, this);
      }
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
